var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20605 16C5.10605 16 4.21605 16.9 4.21605 18C4.21605 19.1 5.10605 20 6.20605 20C7.30605 20 8.20605 19.1 8.20605 18C8.20605 16.9 7.30605 16 6.20605 16ZM0.206055 0V2H2.20605L5.80605 9.59L4.45605 12.04C4.29605 12.32 4.20605 12.65 4.20605 13C4.20605 14.1 5.10605 15 6.20605 15H18.2061V13H6.62605C6.48605 13 6.37605 12.89 6.37605 12.75L6.40605 12.63L7.30606 11H14.7561C15.5061 11 16.1661 10.59 16.5061 9.97L20.0861 3.48C20.1661 3.34 20.2061 3.17 20.2061 3C20.2061 2.45 19.7561 2 19.2061 2H4.41605L3.47605 0H0.206055ZM16.2061 16C15.1061 16 14.2161 16.9 14.2161 18C14.2161 19.1 15.1061 20 16.2061 20C17.3061 20 18.2061 19.1 18.2061 18C18.2061 16.9 17.3061 16 16.2061 16Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.75f5658b.svg";
export { ForwardRef as ReactComponent };